import arial from "@/assets/fonts/arial.ttf";
import calibri from "@/assets/fonts/calibri.ttf";
import CALIST from "@/assets/fonts/CALIST.TTF";
import cambria from "@/assets/fonts/cambria.ttc";
import Candara from "@/assets/fonts/Candara.ttf";
import comic from "@/assets/fonts/comic.ttf";
import consola from "@/assets/fonts/consola.ttf";
import constan from "@/assets/fonts/constan.ttf";
import kaiu from "@/assets/fonts/kaiu.ttf";
import mingliu from "@/assets/fonts/mingliu.ttc";
import NotoSansTCRegular from "@/assets/fonts/NotoSansTCRegular.ttf";
import NotoSerifTCRegular from "@/assets/fonts/NotoSerifTCRegular.ttf";
import PMingLiU from "@/assets/fonts/PMingLiU.ttf";
import simsun from "@/assets/fonts/simsun.ttc";
import times from "@/assets/fonts/times.ttf";
import TWKai from "@/assets/fonts/TWKai.ttf";
import TWSung from "@/assets/fonts/TWSung.ttf";

const fontFaces = [
  { name: 'Arial', url: arial },
  { name: 'Calibri', url: calibri },
  { name: 'Calisto MT', url: CALIST },
  { name: 'Cambria', url: cambria },
  { name: 'Candara', url: Candara },
  { name: 'Comic Sans MS', url: comic },
  { name: 'Consola', url: consola },
  { name: 'Constantia', url: constan },
  { name: 'DFKai-SB', url: kaiu },
  { name: 'MingLiu', url: mingliu },
  { name: 'Noto Sans TC', url: NotoSansTCRegular },
  { name: 'Noto Serif TC', url: NotoSerifTCRegular },
  { name: 'PMingLiU', url: PMingLiU },
  { name: 'NSimSun', url: simsun },
  { name: 'Times New Roman', url: times },
  { name: 'TW-Kai', url: TWKai },
  { name: 'TW-Sung', url: TWSung },
];

const CssBaseLine = () => {
  const fontFaceStyles = fontFaces
    .map(
      (font) => `
        @font-face {
          font-family: '${font.name}';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          src: local('${font.name}'), url(${font.url}) format('truetype');
        }
      `
    )
    .join('\n');

  return {
    MuiCssBaseline: {
      styleOverrides: fontFaceStyles,
    },
  };
};


export default CssBaseLine;
